import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200/60"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-[#0A0A0B] flex items-center justify-center">
            <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none">
              <path d="M4 20 L12 4 L20 20 L17 20 L15.4 16 L8.6 16 L7 20 Z" fill="#fff" />
              <path d="M9.7 13 L12 8 L14.3 13 Z" fill="#2563EB" />
            </svg>
          </div>
          <div className="leading-none">
            <div className="font-heading font-bold text-[15px] tracking-tight text-slate-950">
              AUTEXIO
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-slate-400 mt-0.5">
              IT · DE
            </div>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageSwitcher />
          {user && (
            <button
              data-testid="logout-button"
              onClick={logout}
              className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/80 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-50 transition-colors"
              title={t("auth.logout")}
            >
              <LogOut className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">{t("auth.logout")}</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
